// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hLyP","title":"styles_title__1E5zM"};